import { render, staticRenderFns } from "./BlackForAffiliate.vue?vue&type=template&id=202079a2&"
import script from "./BlackForAffiliate.vue?vue&type=script&lang=js&"
export * from "./BlackForAffiliate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports